import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ASCIIPipe, CachingService, MailingService, MailConfig, MailAccount, MailingDefault, MailAttachment, Scope } from "../../../../../../projects/jv-common/src/public_api";
import { MessageBoxComponent } from "../../../../../../projects/jv-ui/src/lib/popups/message-box/message-box.component";
import { ApiService, SourceAccount, TargetAccount, VendorDebtRecord, ExcelService, BankingService } from "../../../../../../projects/accounting/src/public_api";
import { DecimalPipe, DatePipe } from '@angular/common';

declare var $: any;

export enum MassTransferEditorMode {
  list = 'list',
  select = 'select'
}

export interface MassTransferEditorData {
  records: Array<VendorDebtRecord>;
  title: string;
  period: string;
  mode: MassTransferEditorMode
}

@Component({
  selector: 'mass-transfer-editor',
  templateUrl: './mass-transfer-editor.component.html',
  styleUrls: ['./mass-transfer-editor.component.scss']
})
export class MassTransferEditorComponent implements OnInit, OnDestroy {

  static groups = [];
  private emails = ['aha@ahacafe.vn', 'hoai4285@gmail.com', 'ketoan@ahacafe.vn'];
  private draftEmails = ['ketoan@ahacafe.vn'];
  // private draftEmails = ['chinhdays@gmail.com'];
  // private emails = ['chinhdays@gmail.com'];

  @Input() data: MassTransferEditorData;

  loading = false;
  accounts = this.banking.sources;
  history = {};

  orders: any;
  errors: any;
  Messenger = '';
  step = 1;


  selector = {
    config: {
      search: true,
      height: 'auto',
      placeholder: 'Thêm nhà cung cấp',
      noResultsFound: 'Không tìm thấy nhà cung cấp!',
      searchPlaceholder: 'Tìm kiếm'
    },

    options: [],
    lookup: {},
    selected: null
  }

  constructor(
    public bsModal: BsModalRef,
    private excel: ExcelService,
    private ascii: ASCIIPipe,
    private date: DatePipe,
    private modalService: BsModalService,
    private api: ApiService,
    private mail: MailingService,
    private decimal: DecimalPipe,
    private cache: CachingService,
    private banking: BankingService
  ) {
  }

  addOrder($event) {

    if (typeof $event.value == "undefined") return;

    this.orders.push(this.selector.lookup[$event.value]);
    this.selector.options = this.selector.options.filter(i => i != $event.value);
    this.selector.selected = null;
  }

  removeOrder(order) {

    this.orders = this.orders.filter(i => i != order);

    let buffer = [];
    this.selector.options.forEach(i => buffer.push(i));
    buffer.push(order.info.name);

    this.selector.options = buffer;
  }

  indexOf(array: Array<any>, name: string, onFailed: number) {

    for (let i = 0; i < array.length; i++) {
      if (array[i].name == name) return i;
    }

    return onFailed;
  }

  getHistory(id, name, defaultValue = null) {
    let key = "vendor_" + id;
    return typeof this.history[key] == "object" && typeof this.history[key][name] != "undefined" ? this.history[key][name] : defaultValue;
  }

  ngOnInit() {

    this.loading = true;

    this.cache.get("mass-transfer-history", {}, Scope.GLOBAL).subscribe(data => {

      this.history = data;

      let buffer: any = {};
      for (let o in this.history) {
        if (this.history[o].group != null && this.history[o].group != '') buffer[this.history[o].group] = true;
      }

      MassTransferEditorComponent.groups = [];
      for (let o in buffer) MassTransferEditorComponent.groups.push(o);

      this.orders = [];
      this.errors = [];

      (this.data.mode == MassTransferEditorMode.list ? this.data.records.filter(vendor => vendor.debt > vendor.returned) : this.data.records).forEach(i => {

        let history = {
          source: this.getHistory(i.info.id, 'source', ''),
          target: this.getHistory(i.info.id, 'target', '')
        };

        i.accounts.forEach(account => account.owner = this.ascii.transform(account.owner).toUpperCase());

        let obj = {

          required: this.data.mode == MassTransferEditorMode.list ? i.debt - i.returned : i.debt - i.deposits,
          group: this.getHistory(i.info.id, 'group', ''),

          parts: [
            {
              amount: this.data.mode == MassTransferEditorMode.list ? i.debt - i.returned : i.debt - i.deposits,

              sourceIndex: Math.max(0, this.banking.sources.findIndex(v => v.name == history.source)),
              source: null,

              targetIndex: Math.max(0, i.accounts.findIndex(v => v.name == history.target)),
              target: null,

              internal: false,
              transferable: false,
              notes: '',
            }
          ],

          targets: i.accounts,

          info: i.info
        };

        obj.parts[0].targetIndex = this.indexOf(obj.targets, this.getHistory(obj.info.id, 'target'), 0);
        obj.parts[0].sourceIndex = this.indexOf(this.banking.sources, this.getHistory(obj.info.id, 'source'), 0);

        this.updateBank(null, obj.parts[0], obj);

        if (this.banking.sources.filter(source => i.accounts.filter(target => this.banking.getTransferInfo(source, target) != null).length > 0).length > 0 && i.accounts.filter(account => this.banking.validate(account).valid).length > 0) {

          if (this.data.mode == MassTransferEditorMode.list) {
            this.orders.push(obj);
          }
          else {
            this.selector.options.push(obj.info.name);
            this.selector.lookup[obj.info.name] = obj;
          }

        }
        else {
          this.errors.push(obj);
        }
      });
      this.orders = this.orders.filter(i => i.required > 1000);
      if (this.errors.length == 0) this.step++;
      this.loading = false;
    });
  }

  ngOnDestroy() {

    this.orders.forEach(o => this.history["vendor_" + o.info.id] = { group: o.group, source: o.parts[0].source.name, target: o.parts[0].target.name });
    this.cache.set("mass-transfer-history", this.history, Scope.GLOBAL).subscribe(result => { });
  }

  transferable(from: SourceAccount, to: TargetAccount) {
    return this.banking.getTransferInfo(from, to) != null;
  }

  error(account: TargetAccount) {

    let errors = [];

    if (account.owner == '' || account.owner == null) errors.push("tên chủ tài khoản");
    if (account.account == '' || account.account == null) errors.push("số tài khoản");
    if (account.globalBankName == '' || account.globalBankName == null) errors.push("tên ngân hàng");
    if (account.globalBranchName == '' || account.globalBranchName == null) errors.push("tên chi nhánh");

    return errors.join(", ");
  }

  addPart(order) {

    let part = { amount: 0 };
    for (let o in order.parts[0]) if (typeof part[o] == "undefined") part[o] = order.parts[0][o];

    order.parts.push(part);
  }

  removePart(order, part) {
    order.parts = order.parts.filter(i => i != part);
  }

  getIndex(i) {
    if (i.separation.length == 0) return 1;
    let max = 1;
    i.separation.forEach(ii => {
      if (ii.Index > max) max = ii.Index;
    });
    return ++max;
  }

  generateWaring(i) {

    let amount = 0;

    i.parts.forEach(p => amount += p.amount);

    if (i.required > amount) {
      return '<span class="text-warning">Thiếu ' + this.decimal.transform(i.required - amount, '1.0-0', 'en-US') + '</span>'
    }
    if (i.required < amount) {
      return '<span class="text-danger">Thừa ' + this.decimal.transform(amount - i.required, '1.0-0', 'en-US') + '</span>'
    }
    if (i.required == amount) {
      return '<span class="text-success">Đủ</span>'
    }
  }

  remove(i, ii) {
    i.separation = i.separation.filter(o => o.Index != ii.Index);
  }

  findChoices(searchText: string) {
    return MassTransferEditorComponent.groups.filter(group => group.toLowerCase().includes(searchText.toLowerCase()));
  }

  getChoiceLabel(choice: string) {
    return `${choice}`;
  }

  onBlur(order) {
    if (order.group.indexOf('@') < 0 && MassTransferEditorComponent.groups.filter(group => group == order.group).length == 0) {
      MassTransferEditorComponent.groups.push(order.group);
    }
  }

  isValidBankInfo(order) {
    return this.banking.validate(order.target).transferable;
  }

  createMail(emails): Promise<MailConfig> {

    return new Promise<MailConfig>(resolve => {

      setTimeout(() => {
        let mail: MailConfig = {
          receivers: emails,
          name: 'Kế Toán AHA',
          account: MailAccount.Report,
          subject: '[' + this.date.transform(new Date(), 'dd/MM/yy HH:mm:ss') + '] ' + (this.data.mode == MassTransferEditorMode.list
            ? 'Yêu cầu thanh toán công nợ theo lô cho nhà cung cấp T' + this.data.period
            : 'Yêu cầu tạm ứng theo lô cho nhà cung cấp'),
          content: '',
          css: MailingDefault.Style
        };

        let dataEx = [];
        this.orders.forEach(o => {

          o.parts.filter(i => i.amount > 0 && i.transferable).forEach(p =>
              dataEx.push({ info: o.info, required: o.required, group: o.group, amount: p.amount, source: p.source, target: p.target, internal: p.internal, transferable: p.transferable, notes: o.notes }));
        });
        mail.attachments = this.generateAttachments(dataEx);

        let OldTransferInfo = {};
        let GroupChoices = [];

        dataEx.forEach(i => {
          i.parts.sort((a, b) => a.file > b.file ? 1 : -1);
        });

        let buffer = {};

        dataEx.forEach(i => {

          if (typeof buffer["vendor_" + i.info.id] == "undefined") {
            buffer["vendor_" + i.info.id] = i;
          }
          else {
            i.parts.forEach(p => buffer["vendor_" + i.info.id].parts.push(p));
            buffer["vendor_" + i.info.id].amount += i.amount;
          }
        });

        dataEx = [];
        for (let o in buffer) dataEx.push(buffer[o]);

        mail.content += this.generateGroupReport(dataEx);

        this.banking.sources.forEach(account => {

          let buffer = dataEx.filter(i => i.source.name == account.name);
          if (buffer.length > 0) mail.content += this.generateDetailsReport('CHI TIẾT LỆNH CHUYỂN KHOẢN TỪ ' + account.name, buffer);
        });

        mail.content += this.generateDetailsReport('CHI TIẾT LỆNH CHUYỂN KHOẢN THEO NHÀ CUNG CẤP', dataEx);

        let code = (new Date().getTime() % 10000).toString();
        while (code.length < 4) code = '0' + code;

        let cachingData = {
          code: (this.data.mode == MassTransferEditorMode.list ? 'T' : 'D') + code,
          period: this.data.period,
          orders: [],
          date: new Date().getTime()
        }

        dataEx.forEach(o => o.parts.forEach(i => {
          cachingData.orders.push({ info: o.info, source: i.source, target: i.target, amount: i.amount});
        }));

        this.cache.set(this.data.mode == MassTransferEditorMode.list ? 'last-mass-transfer' : 'last-mass-deposit', cachingData).subscribe(succeed => { });

        mail.content += '<div style="background-color:lightgray; padding: 10px; margin-top: 10px; text-align: center"><small>MÃ XÁC NHẬN LỆNH</small><br><b>' + cachingData.code + '</b></div>'

        resolve(mail);
      }, 200);
    });
  }

  send() {

    this.loading = true;

    this.createMail(this.emails).then(mail => {

      this.mail.send(mail, succeed => {

        this.loading = false;

        if (succeed) this.bsModal.hide();

        this.modalService
          .show(MessageBoxComponent, {
            class: 'modal-md', initialState: {
              data: {
                content: succeed
                  ? '<div class="text-success text-center"><b>Yêu cầu ' + (this.data.mode == MassTransferEditorMode.list ? 'thanh toán công nợ' : 'tạm ứng') + ' theo lô đã được gửi thành công.</b></div>'
                  : '<div class="text-danger text-center"><b>Có lỗi không gửi được mail, vui lòng thử lại</b></div>',
                buttons: [{ name: 'OK', class: succeed ? 'bg-success' : 'bg-danger' }]
              }
            }
          });
      });
    });
  }
  sendDraft(){
    this.loading = true;

    this.createMail(this.draftEmails).then(mail => {

      this.mail.send(mail, succeed => {

        this.loading = false;

        if (succeed) this.bsModal.hide();

        this.modalService
            .show(MessageBoxComponent, {
              class: 'modal-md', initialState: {
                data: {
                  content: succeed
                      ? '<div class="text-success text-center"><b>Tạo phiếu gộp ' + (this.data.mode == MassTransferEditorMode.list ? 'thanh toán công nợ' : 'tạm ứng') + ' theo lô đã được gửi thành công.</b></div>'
                      : '<div class="text-danger text-center"><b>Có lỗi không gửi được mail, vui lòng thử lại</b></div>',
                  buttons: [{ name: 'OK', class: succeed ? 'bg-success' : 'bg-danger' }]
                }
              }
            });
      });
    });
  }

  generateGroupReport(data) {

    let html = '<p>THỐNG KÊ THEO NHÓM NHÀ CUNG CẤP</p>'
    html += '<table>';
    html += '<thead>';
    html += '<tr>';
    html += '<th class="text-left">Nhóm</th>';

    this.banking.sources.forEach(account => html += '<th class="text-right">' + account.name + '</th>')

    html += '<th class="text-right">TỔNG</th>';

    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';

    let buffer = {};

    data.forEach(i => {

      let group = i.group == '' ? 'Còn lại' : i.group.trim();

      if (typeof buffer[group] == "undefined") buffer[group] = {};
      if (typeof buffer[group][i.source.name] == "undefined") buffer[group][i.source.name] = 0;

      buffer[group][i.source.name] += i.amount;

    });

    let total = 0;
    let accTotal = {};
    for (let group in buffer) {

      html += '<tr>';
      html += '<td>' + group + '</td>';

      let groupTotal = 0;

      this.banking.sources.forEach(account => {

        let amount = typeof buffer[group][account.name] == "undefined" ? 0 : buffer[group][account.name];

        html += '<td class="text-right">' + this.decimal.transform(amount, '1.0-0', 'en-US') + '</td>';

        if (typeof accTotal[account.name] == "undefined") accTotal[account.name] = 0;

        groupTotal += amount;
        accTotal[account.name] += amount;
      });

      html += '<td class="text-right"><b>' + this.decimal.transform(groupTotal, '1.0-0', 'en-US') + '</b></td>';
      html += '</tr>';

      total += groupTotal;
    }

    html += '<tr>';
    html += '<td><b>TỔNG</b></td>';

    this.banking.sources.forEach(account => html += '<td class="text-right"><b>' + this.decimal.transform(accTotal[account.name], '1.0-0', 'en-US') + '</b></td>');

    html += '<td class="text-right"><b>' + this.decimal.transform(total, '1.0-0', 'en-US') + '</b></td>';
    html += '</tr>';
    html += '</tbody></table>';

    return html;
  }


  generateDetailsReport(title, data) {
    let html = '<p>' + title + '</p>'
    html += '<table>';
    html += '<thead>';
    html += '<tr>';
    html += '<th class="text-left">Nhà cung cấp</th>';
    html += '<th class="text-left">Nhóm</th>';
    html += '<th class="text-left">TK Gửi</th>';
    html += '<th class="text-left">TK Nhận</th>';
    html += '<th class="text-right">Số tiền</th>';
    html += '<th class="text-right">Cần trả</th>';
    html += '<th class="text-right">Thừa</th>';
    html += '<th class="text-right">Thiếu</th>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';

    let amount = 0;
    let required = 0;
    let excess = 0;
    let debt = 0;

    data.forEach(order => {

      amount += order.amount;
      required += order.required;
      excess += order.required < order.amount ? order.amount - order.required : 0;
      debt += order.required > order.amount ? order.required - order.amount : 0;

      for (let i = 0; i < order.parts.length; i++) {

        let part = order.parts[i];

        html += '<tr>';
        if (i == 0) {
          html += '<td rowspan="' + (order.parts.length > 1 ? order.parts.length + 1 : 1) + '"><b>' + order.info.name + '</b><br/><small>' + order.info.address + '</small></td>';
          html += '<td rowspan="' + (order.parts.length > 1 ? order.parts.length + 1 : 1) + '"><b>' + order.group + '</b></td>';
        }

        html += '<td><b>' + part.source.name + '</b><br/><small>' + part.file + '</small></td>';
        html += '<td><b>' + part.target.owner + ' (' + part.target.account + ')</b><br/><small>' + part.target.globalBankName + ' - ' + part.target.globalBranchName + '</small ></td>';
        html += '<td class="text-right text-danger">' + (order.parts.length == 1 ? '<b>' : '') + this.decimal.transform(part.amount, "1.0-0", "en-US") + (order.parts.length == 1 ? '</b>' : '') + '</td>';

        if (i == 0) {
          html += '<td' + (order.parts.length > 1 ? ' style="vertical-align: bottom"' : '') + ' rowspan="' + (order.parts.length > 1 ? order.parts.length + 1 : 1) + '" class="text-right text-primary"><b>' + this.decimal.transform(order.required, '1.0-0', 'en-US') + '</b></td>';
          html += '<td' + (order.parts.length > 1 ? ' style="vertical-align: bottom"' : '') + ' rowspan="' + (order.parts.length > 1 ? order.parts.length + 1 : 1) + '" class="text-right' + (order.required < order.amount ? ' text-danger' : '') + '"><b>' + this.decimal.transform(order.required < order.amount ? order.amount - order.required : 0, '1.0-0', 'en-US') + '</b></td>';
          html += '<td' + (order.parts.length > 1 ? ' style="vertical-align: bottom"' : '') + ' rowspan="' + (order.parts.length > 1 ? order.parts.length + 1 : 1) + '" class="text-right"><b>' + this.decimal.transform(order.required > order.amount ? order.required - order.amount : 0, '1.0-0', 'en-US') + '</b></td>';
        }

        html += '</tr>';
      }

      if (order.parts.length > 1) {
        html += '<tr>';
        html += '<td colspan="2" class="text-left"><b>TỔNG</b></td>';
        html += '<td class="text-right text-danger"><b>' + this.decimal.transform(order.amount, '1.0-0', 'en-US') + '</b></td>';
        html += '</tr>';
      }
    });

    html += '<tr>';
    html += '<td colspan="4"><b>TỔNG</b></td>';
    html += '<td class="text-right text-danger"><b>' + this.decimal.transform(amount, '1.0-0', 'en-US') + '</b></td>';
    html += '<td class="text-right text-primary"><b>' + this.decimal.transform(required, '1.0-0', 'en-US') + '</b></td>';
    html += '<td class="text-right' + (excess > 0 ? ' text-danger' : '') + '"><b>' + this.decimal.transform(excess, '1.0-0', 'en-US') + '</b></td>';
    html += '<td class="text-right"><b>' + this.decimal.transform(debt, '1.0-0', 'en-US') + '</b></td>';
    html += '</tr>';

    html += '</tbody></table>';

    return html;
  }

  generateAttachments(data: any) {

    let groups = {};

    data.forEach(i => {

      let key = i.group == '' ? "default" : i.group;
      if (typeof groups[key] == "undefined") groups[key] = [];

      groups[key].push(i);
    });

    let results: Array<MailAttachment> = [];

    let time = this.data.period[0] == '0' ? this.data.period.substring(1, this.data.period.length).replace('-', '_') : this.data.period.replace('-', '_');

    for (let group in groups) {

      this.banking.sources.forEach(account => {

        let prefix = (group == 'default' ? '' : group.trim().toLocaleUpperCase().replace(/ /g, '_') + '_') + account.name + '_T' + time + '_';

        let sender = account.name.lastIndexOf('_') > 0 ? account.name.substr(account.name.lastIndexOf('_') + 1) : 'AHA';

        if (account.internalXLSExtractor == account.externalXLSExtractor) {

          let orders = this.group(sender, groups[group].filter(i => i.source.name == account.name), Math.min(account.internalLimit, account.externalLimit));

          for (let i = 0; i < orders.length; i++) {

            results.push({
              filename: prefix + (i + 1) + '_' + orders.length + '.xls',
              base64Content: this.excel.jsonToBase64XLS(account.internalXLSExtractor(account, orders[i]))
            });

            orders[i].forEach(o => o.file = prefix + (i + 1) + '_' + orders.length);
          }
        }
        else {

          let internal = this.group(sender, groups[group].filter(i => i.source.name == account.name && i.internal), account.internalLimit);

          for (let i = 0; i < internal.length; i++) {

            results.push({
              filename: 'NB_' + prefix + (i + 1) + '_' + internal.length + '.xls',
              base64Content: this.excel.jsonToBase64XLS(account.internalXLSExtractor(account, internal[i]))
            });

            internal[i].forEach(o => o.file = 'NB_' + prefix + (i + 1) + '_' + internal.length);
          }

          let external = this.group(sender, groups[group].filter(i => i.source.name == account.name && !i.internal), account.externalLimit);

          for (let i = 0; i < external.length; i++) {

            results.push({
              filename: 'LNH_' + prefix + (i + 1) + '_' + external.length + '.xls',
              base64Content: this.excel.jsonToBase64XLS(account.externalXLSExtractor(account, external[i]))
            });

            external[i].forEach(o => o.file = 'LNH_' + prefix + (i + 1) + '_' + external.length);
          }
        }
      });
    }

    return results;
  }

  updateBank($event, part, order) {

    part.source = this.banking.sources[part.sourceIndex];

    part.target = {};
    for (let o in order.targets[part.targetIndex]) part.target[o] = order.targets[part.targetIndex][o];

    let info = this.banking.getTransferInfo(part.source, part.target);

    part.transferable = info != null;
    part.internal = part.source.globalBankName == part.target.globalBankName;

    if (!part.transferable) {

      if ($event != null) alert('Không thể chuyển từ ' + part.source.globalBankName + ' tới ' + part.target.globalBankName + (part.target.globalBranchName != '' ? ' chi nhánh ' + part.target.globalBranchName : ' không chỉ định chi nhánh'));
      part.amount = 0;
    }
    else {
      for (let o in info) part.target[o] = info[o];
    }
  }

  isTransferable(part, account) {
    return this.banking.getTransferInfo(account, part.target) != null;
  }

  maxsub(index: number, source: Array<any>, limit: number) {

    switch (source.length - index) {

      case 0:
        return { trace: null, sum: 0 };

      case 1:
        return source[index].amount > limit ? { trace: null, sum: 0 } : {
          trace: { index: index, next: null },
          sum: source[index].amount
        };

      default:

        let result = { trace: { index: index, next: null }, sum: 0 };

        let nextlimit = limit - source[index].amount;

        for (let i = source.length - 1; i > index; i--) {

          if (source[i].amount > nextlimit) break;

          let test = this.maxsub(i, source, nextlimit);

          if (test.sum > result.sum) {

            result.sum = test.sum;
            result.trace.next = test.trace;
          }
        }

        result.sum += source[index].amount;

        return result;
    }
  }

  group(sender: string, source: Array<any>, limit: number) {

    let results = [];

    for (let i = 0; i < source.length; i++) {

      let count = Math.ceil(source[i].amount / limit);
      let part = 1;

      let clone = {
        notes: this.ascii.transform(sender + ' TT ' + source[i].info.name + (count > 1 ? ' LAN ' + count + ' TREN ' + count : '')).toUpperCase(),
        amount: source[i].amount
      }

      source[i].parts = [];

      for (let o in source[i]) if (typeof clone[o] == "undefined") clone[o] = source[i][o];

      source[i].parts.push(clone);

      while (clone.amount > limit) {

        clone.amount -= limit;

        let order = {
          notes: this.ascii.transform(sender + ' TT ' + source[i].info.name + (count > 1 ? ' LAN ' + part + ' TREN ' + count : '')).toUpperCase(),
          amount: limit
        };

        for (let o in clone) if (typeof order[o] == "undefined") order[o] = clone[o];

        results.push([order]);
        source[i].parts.push(order);

        part++;
      }

      source[i] = clone;
    }

    // remove invalid requests
    let left = source.filter(i => i.amount > 0).sort((a, b) => a.amount > b.amount ? -1 : 1);

    // get orders
    while (left.length > 0) {

      let trace = this.maxsub(0, left, limit).trace;
      let order = [];

      while (trace != null) {

        order.push(left[trace.index]);
        left[trace.index] = null;
        trace = trace.next;
      }

      left = left.filter(i => i != null);

      results.push(order.sort((a, b) => a.amount > b.amount ? -1 : 1));
    }

    return results;
  }
}
